export const locale = {
	lang: 'es',
	data: {
		menu_pwa: 'PWAs',
		
		my_companies_header_navbar: 'Mis empresas',
		companies_search: 'Escribe para buscar',

		language_header_navbar: 'Idiomas',
		theme_mode_header_navbar: 'Modo del tema',
		account_manage_header_navbar: 'Gestionar cuenta',
		sign_out_header_navbar: 'Cerrar sesión',
		light_mode_header_navbar: 'Claro',
		dark_mode_header_navbar: 'Oscuro',
		system_mode_header_navbar: 'Sistema',
		add_company_header_navbar: 'Empresa',

		en_EN: 'Inglés',
		fr_FR: 'Francés',
		es_ES: 'Español',
		pt_PT: 'Portugués',

		drawer_back: 'Atrás',
		drawer_create: 'Crear',
		drawer_update: 'Actualizar',

		paginator_showing: 'Mostrando',
		paginator_items: 'elementos',
		paginator_of: 'de',

		you_are_about_to_delete: '¡Estás a punto de eliminar {{typeTitle}} {{itemName}}!',
		once_deleted: 'Una vez eliminado, este elemento no puede ser recuperado.',
		are_you_sure: '¿Estás seguro de que quieres eliminar?',
		cancel: 'Cancelar',
		i_want_to_delete: 'Quiero eliminar',

		the_company_will_no_longer: 'La empresa ya no aparecerá en la lista. Todos los datos de la empresa serán eliminados.',
		create_a_company: 'Crear tu empresa',
		create_company_information: 'Información de la empresa',
		create_company_information_description: 'Por favor, proporciona la información comercial sobre tu empresa. Para fines de facturación, presta atención a todos los campos marcados con *.',

		create_company_form_label_name: 'Nombre',
		create_company_form_label_legal_name: 'Razón social',
		create_company_form_label_vat: 'CIF/NIF',
		create_company_form_label_email: 'Correo electrónico',
		create_company_form_label_city: 'Ciudad',
		create_company_form_label_country: 'País',
		create_company_form_label_address: 'Dirección',
		create_company_form_label_zipcode: 'Código postal',
		create_company_form_label_phone: 'Teléfono de contacto',
		create_company_form_label_website: 'Sitio web',

		create_company_form_label_name_placeholder: 'Ej.: ABC Corporation',
		create_company_form_label_legal_name_placeholder: 'Ej.: ABC Holdings Ltd.',
		create_company_form_label_vat_placeholder: 'Ej.: B12345678',
		create_company_form_label_email_placeholder: 'Ej.: contacto@empresa.com',
		create_company_form_label_city_placeholder: 'Ej.: Madrid',
		create_company_form_label_country_placeholder: 'Ej.: España',
		create_company_form_label_address_placeholder: 'Ej.: 123 Parque empresarial, Calle principal',
		create_company_form_label_zipcode_placeholder: 'Ej.: 28001',
		create_company_form_label_phone_placeholder: 'Ej.: +34 912 345 678',
		create_company_form_label_website_placeholder: 'Ej.: https://www.empresa.com',
		create_company_form_label_name_error: 'El nombre es obligatorio',
		create_company_form_label_legal_name_error: 'La razón social es obligatoria',
		create_company_form_label_vat_error: 'El número de CIF/NIF es obligatorio',
		create_company_form_label_email_error: 'El correo electrónico es obligatorio',

		create_webhook_address_cancelation: 'Dirección Webhook de cancelación',
		create_webhook_address_confirmation: 'Dirección Webhook de confirmación',
		create_webhook_address_sale: 'Dirección Webhook de venta',
		create_webhook_address_cancelation_placeholder: 'Ingresa la dirección webhook de cancelación',
		create_webhook_address_confirmation_placeholder: 'Ingresa la dirección webhook de confirmación',
		create_webhook_address_sale_placeholder: 'Ingresa la dirección webhook de venta',

		create_company_form_click_here_select_logotype: 'Haz clic aquí para seleccionar el logotipo',
		create_company_form_click_here_select_cover_image: 'Haz clic aquí para seleccionar la imagen de portada',

		edit_company_page_title: 'Información de la empresa',
		edit_company_page_description: 'Edita la información de tu empresa',

		create_company_save_company: 'Guardar',

		table_head_label_name: 'Nombre',
		table_head_label_priority: 'Prioridad',
		table_head_label_status: 'Estado',
		table_head_label_actions: 'Acciones',
		table_head_label_start: 'Fecha de inicio',
		table_head_label_end: 'Fecha de fin',
		table_head_label_type: 'Tipo',
		table_head_label_gateways: 'Pasarelas',
		table_head_label_payment_methods: 'Métodos de pago',
		table_head_label_store_name: 'Tienda',
		table_head_label_amount: 'Cantidad',
		table_head_label_start_date: 'Fecha de inicio',
		table_head_label_final_date: 'Fecha de fin',
		table_head_label_date: 'Fecha',
		table_head_label_gateway: 'Pasarela',
		table_head_label_payment_method: 'Método de pago',
		table_head_label_validity: 'Validez',
		table_head_label_stores: 'Tiendas',
		table_head_label_company_name: 'Empresa',
		table_head_label_legal_name: 'Razón social',
		table_head_label_role: 'Rol',
		table_head_label_active: 'Activo',

		active_company_header_navbar: 'Empresa activa',
		active_company_informations_header_navbar: 'Información de la empresa',
		active_company_users_header_navbar: 'Gestión de usuarios',
		active_company_roles_header_navbar: 'Roles de usuario',

		company_user_management_page_title: 'Gestión de usuarios',
		company_user_management_page_description: 'Gestionar usuarios asociados a tu empresa',
		company_user_management_send_invite: 'Enviar invitación',

		toast_user_role_updated: 'Rol del usuario actualizado exitosamente',
		toast_error_updating_user_role: 'Hubo un error al actualizar el rol',

		toast_error_no_grant: 'No tienes permiso para realizar esta acción',

		company_roles_page_title: 'Roles',
		company_roles_page_description: 'Información sobre los roles de usuario vinculados a la empresa',
		company_role_create_role: 'Agregar rol',

		invite_user_drawer_title: 'Invitar usuario',
		invite_user_drawer_description: 'Invita a un nuevo usuario a unirse a la empresa completando el formulario a continuación.',
		invite_user_drawer_email: 'Correo electrónico',
		invite_user_drawer_email_placeholder: 'Correo del usuario',
		invite_user_email_error: 'El correo electrónico es obligatorio',
		invite_user_drawer_role: 'Rol del usuario',
		select_role_placeholder: 'Seleccionar un rol',
		send_invitation: 'Enviar invitación',

		invitation_sent_successfully: 'Invitación enviada exitosamente',
		error_sending_invitation: 'Hubo un error al enviar la invitación',

		the_user: 'el usuario',
		the_user_will_be_removed: 'El usuario será eliminado de la empresa y ya no tendrá acceso a sus recursos.',
		toast_user_role_deleted: 'El usuario ha sido eliminado',
		toast_error_deleting_user_role: 'Ocurrió un error al eliminar al usuario',
		toast_user_role_not_been_deleted: 'El usuario no ha sido eliminado.',

		create_role_drawer_title: 'Crear un rol',
		create_role_drawer_description: 'Completa el formulario para crear el rol. Todos los campos deben ser completados. Los campos marcados con * son obligatorios.',
		create_role_drawer_label_name: 'Nombre',
		create_role_drawer_label_actions: 'Acciones',
		create_role_drawer_label_invites: 'Invitaciones',
		create_role_drawer_label_resource: 'Recursos',
		create_role_drawer_label_active: 'Activo',
		create_role_drawer_label_permissions: 'Permisos',
		create_role_drawer_label_company: 'Empresas',
		create_role_drawer_label_role: 'Roles',
		create_role_drawer_label_users: 'Usuarios',
		create_role_drawer_label_create: 'Crear',
		create_role_drawer_label_read: 'Leer',
		create_role_drawer_label_update: 'Actualizar',
		create_role_drawer_label_delete: 'Eliminar',
		create_role_drawer_label_name_placeholder: 'Nombre del rol',
		create_role_drawer_label_api_keys: 'Claves de acceso API',

		toast_role_created: 'El rol ha sido creado.',
		toast_error_creating_role: 'Ocurrió un error al crear el rol.',
		toast_role_updated: 'El rol ha sido actualizado.',
		toast_error_updating_role: 'Ocurrió un error al actualizar el rol.',
		toast_role_status_updated: 'El estado del rol ha sido actualizado.',
		toast_error_updating_role_status: 'Ocurrió un error al actualizar el estado del rol.',
		toast_role_not_updated: 'El rol no ha sido actualizado.',
		toast_role_not_created: 'El rol no ha sido creado.',
		toast_role_deleted: 'El rol ha sido eliminado.',
		toast_error_deleting_role: 'Ocurrió un error al eliminar el rol.',
		toast_role_not_been_deleted: 'El rol no ha sido eliminado.',
		the_role: 'el rol',
		the_role_will_be_removed: 'El rol será eliminado de todos los lugares donde se esté utilizando.',

		pwa_page_title: 'PWA',
		pwa_page_description: 'Editar tus PWA',
		pwa_create_pwa: 'Crear PWA',
		toast_status_pwa_changed: 'Estado de la PWA cambiado',
		toast_error_changing_pwa_status: 'Error al cambiar el estado de la PWA',

		edit_pwa_drawer_title: 'Editar PWA',
		create_pwa_drawer_title: 'Crear PWA',
		create_edit_pwa_drawer_description: 'Crear o editar tu PWA',
		create_pwa_form_label_name: 'Nombre de la PWA',
		create_pwa_form_label_image: 'Imagen',
		create_pwa_form_label_luope_id: 'ID de Luope',
		create_pwa_form_label_shared_key: 'Clave compartida',
		create_pwa_form_label_subdomain: 'Subdominio',
		create_pwa_form_label_theme: 'Tema',

		create_pwa_form_placeholder_name: 'Insertar nombre',
		create_pwa_form_placeholder_luope_id: 'Insertar ID de Luope',
		create_pwa_form_placeholder_shared_key: 'Insertar clave compartida',
		create_pwa_form_placeholder_subdomain: 'Insertar subdominio',
		create_pwa_form_placeholder_theme: 'Insertar tema',
		update_pwa: 'Actualizar PWA',
		create_pwa: 'Crear PWA',
		toast_pwa_created: 'PWA creada exitosamente',
		toast_error_creating_pwa: 'Hubo un error al crear la PWA',
		toast_pwa_updated: 'PWA actualizada exitosamente',
		toast_error_updating_pwa: 'Hubo un error al actualizar la PWA',

		toast_error_loading_pwa: 'Error al cargar las PWA',
		toast_pwa_not_been_deleted: 'La PWA no ha sido eliminada',
		toast_error_deleting_pwa: 'Hubo un error al eliminar la PWA',
		toast_pwa_deleted: 'PWA eliminada exitosamente',
		invalid_json_format: 'Formato inválido para este campo',

		error_required_field: 'Este campo es obligatorio',

		menu_files: 'Archivos',
		sidebar_more: 'Más',
		company_files_page_title: 'Archivos',
		company_files_page_description: 'Subir y gestionar tus archivos',
		company_files_create_file: 'Archivo',

		create_loading_file_drawer_title: 'Subida de archivo',
		create_loading_file_drawer_description: 'Seguir el progreso de tus archivos',
		create_loading_file_drawer_upload: 'Elegir archivos',

		select_files_drawer_title: 'Selección de archivos',
		select_files_drawer_description: 'Seleccionar los archivos para integrar en la empresa, tienda y/o productos de la tienda',

		toast_files_created: 'Los archivos han sido subidos.',
		toast_files_created_error: 'Ocurrió un error al subir los archivos',
		toast_files_tried_upload_not_accepted: 'Los archivos que intentaste subir no son aceptados. Solo se aceptarán archivos jpeg, jpg, svg o png.',
		toast_file_deleted: 'El archivo ha sido eliminado.',
		toast_error_deleting_file: 'Ocurrió un error al eliminar un archivo.',
		toast_file_not_been_eliminated: 'El archivo no ha sido eliminado.',

		the_file: 'el archivo',
		the_file_will_be_removed: 'El archivo será eliminado de todos los lugares donde se esté utilizando.',

		toast_error_company_files: 'Ocurrió un error al cargar los archivos',
		toast_error_server: 'Se produjo un error al conectar con el servidor. Por favor, inténtalo de nuevo.',

		toast_company_created: 'La empresa se creó correctamente.',
		toast_error_creating_company: 'Se produjo un error al crear la empresa.',
		toast_info_file_selected: 'Archivo seleccionado.',
		toast_company_eliminated: 'La empresa se eliminó correctamente.',
		toast_error_deleting_company: 'Se produjo un error al eliminar la empresa.',
		toast_company_not_been_eliminated: 'La empresa no se eliminó correctamente.',
		toast_company_updated: 'La empresa se actualizó correctamente.',
		toast_error_updating_company: 'Se produjo un error al actualizar la empresa.',
		the_pwa_will_be_removed: 'La PWA será eliminada.',
		the_pwa: 'La PWA',
		location_not_authrozied_warning: 'No se han concedido los permisos de ubicación.',

		create_pwa_form_label_final_message: 'Mensaje de uso de la máquina',
		create_pwa_form_placeholder_final_message: 'Inserta el mensaje de uso de la máquina',
		
		create_pwa_form_label_final_message_switch: 'Mostrar mensaje de uso de la máquina',
		create_pwa_form_label_logo: 'Logo de la PWA',
		create_pwa_form_label_cover: 'Portada de la PWA',

		create_pwa_form_label_customization: 'Personalización',
		create_pwa_form_label_color: 'Color',

		theme_primary_color: 'Color primario',
		theme_secondary_color: 'Color secundario',
		theme_background_color: 'Color de fondo',
		theme_accent_color: 'Color de acento',
		theme_action_color: 'Color de acción',
		theme_success_color: 'Color de éxito',
		theme_warning_color: 'Color de advertencia',
		theme_danger_color: 'Color de peligro',
		theme_logo_cover_color: 'Color de la portada del logo',
		theme_primary_font_color: 'Color de fuente principal',
		theme_secondary_font_color: 'Color de fuente secundaria',
		theme_btn_action_color: 'Color de botón de acción',
		theme_btn_font_action_color: 'Color de texto del botón de acción',
		theme_highlight_font_color: 'Color de texto destacado',

		theme_description_primary_color: 'El color principal utilizado en toda la aplicación',
		theme_description_secondary_color: 'El color secundario utilizado en toda la aplicación',
		theme_description_background_color: 'El color de fondo de la aplicación',
		theme_description_accent_color: 'El color de acento para los resaltados',
		theme_description_action_color: 'El color para los elementos de acción del usuario',
		theme_description_success_color: 'El color para los estados de éxito',
		theme_description_warning_color: 'El color para los estados de advertencia',
		theme_description_danger_color: 'El color para los estados de error',
		theme_description_logo_cover_color: 'El color de la portada del logo',
		theme_description_primary_font_color: 'El color principal del texto',
		theme_description_secondary_font_color: 'El color secundario del texto',
		theme_description_btn_action_color: 'El color de los botones de acción del usuario',
		theme_description_btn_font_action_color: 'El color del texto de los botones de acción del usuario',
		theme_description_highlight_font_color: 'El color del texto destacado',

		reset_theme: 'Restablecer tema',
	}
};
